<template>
  <q-card
    flat
    bordered
    class="full-width full-height panel-padding-alert bg-grey-2"
  >
    <q-card-section class="column items-center full-width full-height">
      <p class="title-alert q-pb-sm col-auto full-width">
        {{ title }}
      </p>
      <div class="column items-center justify-center col-8">
        <q-spinner
          v-if="loading"
          color="primary"
          size="3em"
          :thickness="2"
        />
        <squareAlert
          class="q-mb-sm"
          v-else
        />

        <span class="text-bold q-mb-xs">
          {{ subtitleTitle }}
        </span>
        <span class="">
          {{ subtitleText }}
        </span>
        <q-btn
          v-if="updateButton"
          label="Atualizar painel"
          color="primary"
          outline
          icon-right="mdi-reload"
          padding="10px"
          style="width: 200px; margin-top: 15px;"
          @click="$emit('reload-contact')"
        />
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import squareAlert from '@/assets/icons/squareAlert.svg'
export default {
  components: {
    squareAlert
  },

  props: {
    title: {
      type: String,
      required: true
    },
    subtitleTitle: {
      type: String,
      required: true
    },
    subtitleText: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    updateButton: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="sass" scoped>

.panel-padding-alert
  padding: 10px 30px

.title-alert
  font-weight: 500
  font-size: 20px
  color: #000000
  border-bottom: 1px solid #C5C5C5

</style>
